import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { login } from '../../../Services/LoginServices';
import { utils } from '../../../helpers/utils';
import { saveHomepageSection, getHomepageSectionById, deleteHomepageSectionById } from '../../../Services/AdminServices';

export type HomepageSectionFormValues = {
    [key: string]: any;
}

export type HomepageSectionFormRef = {
    [key: string]: React.RefObject<HTMLElement | null>
}

export type HomepageSectionFormErrors = {
    [key: string]: string;
}

export type HomepageSectionFormTouched = {
    [key: string]: boolean;
}

export type ValidtionFunctions = {
    [key: string]: Function;
}

export type HomepageSectionFormMasterData = {
    [key: string]: {
        id: number,
        displayName: string,
        iconName?: string | null,
    }[]
}

export function useEditHomepageSectionForm(isCreate: boolean) {
    let { sectionId } = useParams<{ sectionId: string }>();
    const history = useHistory();
    useEffect(() => {
        fetchData(isCreate !== undefined ? isCreate : true);
    }, []);

    async function fetchData(isCreate: boolean, providerId?: number) {
        try {
            if (isCreate) {
                console.log('creating mode');
            } else {
                // also get provider data
                if (sectionId) {
                    const dataId: number = parseInt(sectionId);
                    getHomepageSectionById(dataId).then((response) => {
                        console.log(response.data);
                        if (response.data) {
                            setValues(response.data as HomepageSectionFormValues);
                        }

                    });
                }

            }
        } catch (error) {
            Swal.fire(
                {
                    icon: 'error',
                    title: 'Error While Processing',
                    text: `Unable to get master data for the form.`,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    confirmButtonColor: '#1678c2'
                }
            ).then(() => {
            });
        }

    }

    const defaultValues: HomepageSectionFormValues = {
        title: '',
        teaserText: '',
        iconName: '',
        backgroundColor: '',
        isHtmlContent: true,
        pageContent: '',
        pageContentContext: '',
        url: '',
    };
    const validations = {

        title: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.title) {
                        error = 'Please enter title';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        teaserText: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.teaserText) {
                        error = 'Please provide teaser text.';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        iconName: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.iconName) {
                        error = 'Please select an icon';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        backgroundColor: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.backgroundColor && values.backgroundColor.length > 0)) {
                        error = 'Please provide background color';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        isHtmlContent: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.isHtmlContent === false || values.isHtmlContent === true)) {
                        error = 'Please select content type';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        pageContent: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        pageContentContext: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        url: async function (values: HomepageSectionFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.url) {
                        error = "Please provide a valid url";
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },

    }

    let isSubmit = false;
    const debounceTime = 250;
    const ref = useRef(initRefs(defaultValues));
    const [values, setValues] = useState<HomepageSectionFormValues>(defaultValues);
    const [errors, setErrors] = useState<HomepageSectionFormErrors>({});
    const [touched, setTouched] = useState<HomepageSectionFormTouched>({});
    //const debouncedValidateForm = _.debounce(validateForm, debounceTime);
    const debouncedValidateForm = validateForm;
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [masterData, setMasterData] = useState<HomepageSectionFormMasterData | null>(null);

    let validationCount = 0;
    let validationTotal = 1;

    function initRefs(viewModel: HomepageSectionFormValues) {
        if (viewModel == null) {
            return {};
        } else {
            let result: HomepageSectionFormRef = {};
            Object.keys(viewModel).forEach((key) => {
                result[key] = React.createRef<HTMLElement | null>();
            });
            return result;
        }
    }

    function registerRef(ref: HTMLElement | null) {
        console.log(ref);
        console.log(typeof ref);
    }

    function touchAll() {
        let keys = Object.keys(defaultValues);
        keys.forEach((key) => {
            touched[key] = true;
        });
        setTouched(touched);
    }

    function counterHit(currentError: HomepageSectionFormErrors) {
        validationCount += 1;
        // we did not handle timeout problem, but it will in future
        if (validationCount === validationTotal) {
            validationCount = 0;
            if (_.isEmpty(currentError)) {
                setIsValid(true);
                if (isSubmit === true) {
                    isSubmit = false;
                    setIsLoading(true);
                    saveData({ ...values });
                } else {
                    setIsLoading(false);
                }
            } else {
                if (isSubmit === true) {
                    isSubmit = false;
                }
                if (isValid !== false) {
                    setIsValid(false);
                }
                setIsLoading(false);
            }


        }
    }

    function saveData(viewModel: HomepageSectionFormValues) {
        setIsSubmitting(true);
        setIsLoading(true);
        setErrorMessage(null);
        let newData = _.cloneDeep(viewModel);
        newData.homepageSectionId = isCreate ? 0 : parseInt(sectionId);
        //console.log(newData);
        saveHomepageSection(newData, false).then((response) => {
            console.log(response);
            setIsSubmitting(false);
            setTimeout(() => {
                history.push('/manageHomepageSections');
            }, 200);
            toastSuccessMessage('All changes saved.');

        }).catch((error) => {
            setIsSubmitting(false);
            console.log(error);
        });

    }

    function toastSuccessMessage(message: string) {
        Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: 'Success',
            text: message,
            timer: 5000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    function resetForm() {
        Object.keys(defaultValues).forEach((key, index) => {
            let temp = ref.current[key].current;
            if (temp != null) {
                // not implemented yet
            }
        });
        setValues(defaultValues);
        setIsLoading(false);
        setTouched({});
        setErrors({});
    }

    async function handleSubmit() {
        touchAll();
        setIsLoading(true);
        validateForm(values, validations, null);
        isSubmit = true;
    }

    function validateForm(values: HomepageSectionFormValues, validations: ValidtionFunctions, fieldName: string | null = null) {
        let newErrors: HomepageSectionFormErrors = {};
        setIsLoading(true);
        if (fieldName != null) {
            // only validate the changing field.Keep current errors info
            newErrors = errors;
            validationTotal = 1;
            validationCount = 0;
            validations[fieldName](values).then(() => {
                delete newErrors[fieldName];
                setErrors(newErrors);
                counterHit(newErrors);
            }, (error: string) => {
                newErrors[fieldName] = error;
                setErrors(newErrors);
                counterHit(newErrors);
            });
        } else {
            // if this validate is not trigered by input control change, validate all.
            let keys = Object.keys(defaultValues);
            validationTotal = keys.length > 0 ? keys.length : 0;
            validationCount = 0;
            keys.forEach((key) => {
                validations[key](values).then(() => {
                    delete newErrors[key];
                    setErrors(newErrors);
                    counterHit(newErrors);
                }, (error: string) => {
                    newErrors[key] = error;
                    setErrors(newErrors);
                    counterHit(newErrors);
                });
            });

        }

    }


    function handleBlur(fieldName: string) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        setTimeout(() => {
            setTouched((prevValue) => {
                return {
                    ...prevValue,
                    [fieldName]: true,
                }
            });
            validateForm(values, validations, null);
        }, 250);
    }

    function handleChange(newValue: any, fieldName: string, fieldOnly = true) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        if (fieldName === 'providerPhone') {
            if (newValue && utils.isValidPhone(newValue)) {
                newValue = utils.formatPhoneNumber(newValue);
                newValue = utils.formatPhoneNumber(newValue);
            }
        }
        values[fieldName] = newValue;
        setValues(values);
        if (!(touched[fieldName] != null)) {
            setTouched({ ...touched, [fieldName]: true });
        }
        debouncedValidateForm(values, validations, fieldOnly ? fieldName : null);
    }

    function isValidEmail(testTarget: string) {
        let myReg = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi;
        return myReg.test(testTarget);
    }

    function handleDelete() {
        const homepageSectionId: number = isCreate ? 0 : parseInt(sectionId);
        if (homepageSectionId !== 0) {
            Swal.fire({
                title: 'Confirm Deletion',
                text: "Would you like to delete this section?",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: 'lightgray',
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    setIsSubmitting(true);
                    setIsLoading(true);
                    setErrorMessage(null);
                    deleteHomepageSectionById(homepageSectionId, false).then((res) => {
                        if (res && res.status === 200) {
                            setTimeout(() => {
                                history.push('/manageHomepageSections');
                            }, 200);
                            toastSuccessMessage('Section deleted.');
                        }
                    }).catch((error) => {
                        setIsSubmitting(false);
                        setIsLoading(false);
                        console.log(error);
                    });
                }
            })
        }
    }



    return [values, masterData, errors, touched, isLoading, isSubmitting, isValid, errorMessage, registerRef, handleChange, handleBlur, handleSubmit,handleDelete] as const;

}
